<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
    variant?: 'legend' | 'label';
}>();
</script>

<template>
    <legend
        data-slot="field-legend"
        :data-variant="variant"
        :class="
            cn(
                'mb-2',
                'data-[variant=legend]:text-base data-[variant=legend]:font-bold',
                'data-[variant=label]:text-sm data-[variant=label]:font-semibold',
                props.class
            )
        "
    >
        <slot />
    </legend>
</template>
